import req from '../lib/req';

export function verify() {
  return req.post('/auth/verify');
}

export function sendRoleId(roleId) {
  return req.post('/auth/role-select', { role_id: roleId });
}
